function getContainers(root = document) {
  if (root instanceof Element && root.matches("[data-student-spn-filter]")) {
    return [root];
  }

  if (root instanceof Document || root instanceof Element) {
    return Array.from(root.querySelectorAll("[data-student-spn-filter]"));
  }

  return [];
}

function parsePayload(container) {
  const payloadElementId = container.dataset.payloadElementId || "";
  const payloadElement = payloadElementId ? document.getElementById(payloadElementId) : null;
  if (!payloadElement) {
    return null;
  }

  try {
    return JSON.parse(payloadElement.textContent || "{}");
  } catch {
    return null;
  }
}

function getField(container, role) {
  return container.querySelector(`[data-student-spn-filter-role="${role}"]`);
}

function normalizeMap(value) {
  if (!value || typeof value !== "object") {
    return {};
  }

  return value;
}

function getCurrentSchoolClass(payload, schoolClassSelect) {
  const classId = String(schoolClassSelect?.value || "");
  if (classId === "") {
    return null;
  }

  return normalizeMap(payload.classes)[classId] || null;
}

function spnMatchesSchoolClass(spn, schoolClass) {
  if (!spn || !schoolClass) {
    return false;
  }

  return (
    Number.parseInt(spn.id_cykl || "0", 10) === Number.parseInt(schoolClass.id_cykl || "0", 10) &&
    Number.parseInt(spn.id_szkola_filia || "0", 10) === Number.parseInt(schoolClass.id_szkola_filia || "0", 10)
  );
}

function selectedValueCanBePreserved(payload, fieldName, value, preserveLegacyMismatch) {
  if (!preserveLegacyMismatch || !value) {
    return false;
  }

  const current = payload.current || {};
  if (String(current[fieldName] || "") !== String(value)) {
    return false;
  }

  const mismatchedFields = Array.isArray(payload.mismatchedFields) ? payload.mismatchedFields : [];
  return fieldName === "id_spn2" ? mismatchedFields.includes("SPN 2") : mismatchedFields.includes("SPN");
}

function refreshTomSelect(selectEl) {
  const tomSelect = selectEl?.tomselect;
  if (!tomSelect) {
    return;
  }

  tomSelect.clearOptions();
  Array.from(selectEl.options).forEach((option) => {
    if (option.disabled && option.value !== "") {
      return;
    }

    tomSelect.addOption({ value: option.value, text: option.textContent || "" });
  });
  tomSelect.refreshOptions(false);
  tomSelect.setValue(selectEl.value || "", true);
}

function filterSpnSelect(payload, schoolClass, selectEl, fieldName, preserveLegacyMismatch, excludedValue) {
  if (!(selectEl instanceof HTMLSelectElement)) {
    return;
  }

  const spns = normalizeMap(payload.spns);
  const selectedValue = String(selectEl.value || "");
  let selectedValueAllowed = selectedValue === "";

  Array.from(selectEl.options).forEach((option) => {
    const optionValue = String(option.value || "");
    if (optionValue === "") {
      option.hidden = false;
      option.disabled = false;
      return;
    }

    const spn = spns[optionValue] || null;
    const isAllowed = (!schoolClass && payload.preserveSelectionUntilClassChosen) || spnMatchesSchoolClass(spn, schoolClass);
    const preserveSelected =
      optionValue === selectedValue &&
      selectedValueCanBePreserved(payload, fieldName, optionValue, preserveLegacyMismatch);

    const isUsedByOtherPlan = optionValue === excludedValue && optionValue !== selectedValue;
    option.hidden = (!isAllowed && !preserveSelected) || isUsedByOtherPlan;
    option.disabled = option.hidden;

    if (optionValue === selectedValue && (isAllowed || preserveSelected)) {
      selectedValueAllowed = true;
    }
  });

  if (!selectedValueAllowed) {
    selectEl.value = "";
    selectEl.dispatchEvent(new Event("change", { bubbles: true }));
  }

  refreshTomSelect(selectEl);
}

function setWarning(container, message) {
  const warning = container.querySelector("[data-student-spn-filter-warning]");
  if (!(warning instanceof HTMLElement)) {
    return;
  }

  const safeMessage = String(message || "").trim();
  warning.textContent = safeMessage;
  warning.classList.toggle("d-none", safeMessage === "");
}

function syncSecondarySpnRequirement(container) {
  const realizationSelect = getField(container, "realization");
  const secondarySpnSelect = getField(container, "spn2");

  if ((!(realizationSelect instanceof HTMLSelectElement) && !(realizationSelect instanceof HTMLInputElement)) || !(secondarySpnSelect instanceof HTMLSelectElement)) {
    return;
  }

  const requiredFor = String(secondarySpnSelect.dataset.studentSpn2RequiredFor || "");
  const isRequired = requiredFor !== "" && String(realizationSelect.value || "") === requiredFor;

  secondarySpnSelect.required = isRequired;
  secondarySpnSelect.setAttribute("aria-required", isRequired ? "true" : "false");

  const label = container.querySelector(`label[for="${secondarySpnSelect.id}"]`);
  if (!(label instanceof HTMLLabelElement)) {
    return;
  }

  const marker = label.querySelector("[data-student-spn2-required-marker]");
  if (isRequired && !marker) {
    const requiredMarker = document.createElement("span");
    requiredMarker.className = "text-danger";
    requiredMarker.dataset.studentSpn2RequiredMarker = "1";
    requiredMarker.textContent = " *";
    label.append(requiredMarker);
  } else if (!isRequired && marker) {
    marker.remove();
  }
}

function applyFilters(container, payload, preserveLegacyMismatch) {
  const schoolClassSelect = getField(container, "school-class");
  const schoolClass = getCurrentSchoolClass(payload, schoolClassSelect);
  const primarySpnSelect = getField(container, "spn");
  const secondarySpnSelect = getField(container, "spn2");

  filterSpnSelect(payload, schoolClass, primarySpnSelect, "id_spn", preserveLegacyMismatch, secondarySpnSelect?.disabled ? "" : secondarySpnSelect?.value);
  filterSpnSelect(payload, schoolClass, secondarySpnSelect, "id_spn2", preserveLegacyMismatch, primarySpnSelect?.value);
  syncSecondarySpnRequirement(container);

  const duplicateMessage = primarySpnSelect?.value && !secondarySpnSelect?.disabled && primarySpnSelect.value === secondarySpnSelect?.value
    ? "SPN i SPN 2 muszą być dwoma różnymi planami."
    : "";
  secondarySpnSelect?.setCustomValidity(duplicateMessage);
  setWarning(container, duplicateMessage || (preserveLegacyMismatch ? payload.warningMessage || "" : ""));
}

function bindContainer(container) {
  const spnLink = container.querySelector('[data-student-spn-link-template]');
  const spnSelect = getField(container, 'spn');
  if (spnLink && spnSelect && !spnLink.dataset.initialized) {
    spnLink.dataset.initialized = '1';
    const updateLink = () => {
      const selected = Number(spnSelect.value) > 0;
      spnLink.classList.toggle('disabled', !selected);
      spnLink.setAttribute('aria-disabled', selected ? 'false' : 'true');
      if (selected) {
        spnLink.href = spnLink.dataset.studentSpnLinkTemplate.replace('__SPN_ID__', encodeURIComponent(spnSelect.value));
        spnLink.setAttribute('data-modal-dynamic', spnLink.href);
        spnLink.removeAttribute('tabindex');
      } else {
        spnLink.removeAttribute('href');
        spnLink.removeAttribute('data-modal-dynamic');
        spnLink.setAttribute('tabindex', '-1');
      }
    };
    spnSelect.addEventListener('change', updateLink);
    updateLink();
  }

  if (container.dataset.studentSpnFilterInitialized === "1") {
    return;
  }

  const payload = parsePayload(container);
  if (!payload || payload.enabled === false) {
    return;
  }

  const schoolClassSelect = getField(container, "school-class");
  if (!(schoolClassSelect instanceof HTMLSelectElement) && !(schoolClassSelect instanceof HTMLInputElement)) {
    return;
  }

  container.dataset.studentSpnFilterInitialized = "1";
  let preserveLegacyMismatch = true;
  applyFilters(container, payload, true);

  schoolClassSelect.addEventListener("change", () => {
    preserveLegacyMismatch = false;
    applyFilters(container, payload, false);
  });

  [spnSelect, getField(container, "spn2")].forEach((select) => {
    select?.addEventListener("change", () => {
      applyFilters(container, payload, preserveLegacyMismatch);
    });
  });

  const realizationSelect = getField(container, "realization");
  if (realizationSelect instanceof HTMLSelectElement) {
    realizationSelect.addEventListener("change", () => {
      applyFilters(container, payload, preserveLegacyMismatch);
    });
  }
}

export function initStudentSpnFilters(root = document) {
  getContainers(root).forEach(bindContainer);
}
